import React from "react";
import { motion } from "framer-motion";
import myImage from "../assets/my-image.jpg.png";

const About = () => {
  return (
    <section
      id="about"
      className="min-h-screen py-20 px-4 sm:px-6 lg:px-8 relative"
    >
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="gradient-text">About Me</span>
          </h2>
          <div className="w-24 h-1 bg-gray-300 mx-auto rounded-full"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image Section */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="flex justify-center"
          >
            <div className="relative">
              <div className="absolute inset-0 bg-gray-500 rounded-full blur-2xl opacity-20 animate-pulse"></div>
              <motion.img
  src={myImage}
  alt="Profile"
  className="relative w-72 h-72 rounded-full object-cover border-4 border-gray-400 shadow-2xl"
  whileHover={{ scale: 1.05 }}
  transition={{ duration: 0.3 }}
/>



            </div>
          </motion.div>

          {/* Content Section */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="space-y-6"
          >
            <div className="glass rounded-2xl p-8 backdrop-blur-xl">
              <p className="text-lg text-gray-200 leading-relaxed">
                Full-Stack Developer specializing in{" "}
                <span className="font-semibold text-white">
                  Cloud, DevOps, and modern web technologies
                </span>
                . Skilled in building responsive, scalable applications using{" "}
                <span className="font-semibold text-white">
                  React, Node.js, Express, and MongoDB
                </span>
                , with hands-on experience in{" "}
                <span className="font-semibold text-white">
                  Docker, Jenkins, and automation tools
                </span>
                . Passionate about integrating{" "}
                <span className="font-semibold text-white">AI APIs</span>,
                crafting intuitive UIs, and delivering seamless
                frontend-backend experiences with a focus on{" "}
                <span className="font-semibold text-white">
                  clean code and efficient design
                </span>
                .
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
